import { useQuery } from "@tanstack/react-query";

import { useRestAPI } from "../useRestAPI";

export const useHealthQuery = () => {
  const api = useRestAPI();
  return useQuery({ queryKey: ["health"], queryFn: () => api.health.health() });
};
